import React from 'react';
import { Button } from 'primereact/button';
import { useAuthContext } from '../hooks/useAuthContext';

const MeaButton = ({ permission, children, ...props }) => {
    const { hasPermission } = useAuthContext();

    const didHasPermission = hasPermission(permission);
    if (permission !== undefined && !didHasPermission) {
        return (
            <Button disabled tooltip="Vous n'avez pas les permissions nécessaires" {...props}>
                {children}
            </Button>
        )
    }
    return (
        <Button {...props}>
            {children}
        </Button>
    );
};

export default MeaButton;
